// ============================================================================
// House bot presentation helpers - shared by every table renderer so a bot
// looks the same (face + disclosure) on classic, premium, and mobile felts.
// ============================================================================

// PSS character busts served from /public/avatars/pss/. Deterministic per
// bot id so a bot keeps its face for the whole session.
export const PSS_BUSTS = ['ace', 'bluff', 'dash', 'diamond', 'feels', 'fish', 'ivy', 'jaw',
  'lux', 'maverick', 'moondog', 'nova', 'ribbit', 'rio', 'stonks', 'tilt'];

export const pssBustForBot = (botId: string): string => {
  let h = 0;
  for (let i = 0; i < botId.length; i++) h = (h * 31 + botId.charCodeAt(i)) >>> 0;
  return `/avatars/pss/${PSS_BUSTS[h % PSS_BUSTS.length]}_bust.svg`;
};

export const isHouseBotId = (id: unknown): boolean =>
  typeof id === 'string' && id.startsWith('house_bot_');

// Bot chat is voiced on the felt - strip emojis there (clean-UI rule);
// the writing survives fine without them.
export const stripEmoji = (s: string): string =>
  s.replace(/[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\u{2B00}-\u{2BFF}\u{FE0F}\u{1F1E6}-\u{1F1FF}]/gu, '')
    .replace(/\s{2,}/g, ' ')
    .trim();
